import {useState,useEffect} from "react";
import {Link} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../../../core/img";
import {all_routes} from "../../../router/all_routes";
import Table from "../../../../core/dataTable/non-pager/index";
import Select from "react-select";
import {Toaster} from 'react-hot-toast';
/* -- biz9 import start -- */
import {Image_Type,Image_Table,Image_Format} from "biz9-image";
import {Str,DateTime} from "biz9-utility";
import {User_Table} from "biz9-user";
import {Store_Field} from "biz9-store";
import {Message,Type,Url,Field,Title} from "../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,User,Toast_Message,Template,Storage,System} from "../../../../project";
import {Data_Logic} from "biz9-data-app";

import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table,Portal_Field,Portal_Remote_Image} from "biz9-portal-app";

/* -- biz9 import end -- */
const Dashboard_Admin_Stat = () => {
    const [user,setUser] = useState(User.get());
    const [val_sub_page_title,setValSubPageTitle] = useState(Str.get_table_by_name(Portal_Table.STAT,{plural:true}));
    const [val_search,setValSearch] = useState("");
    const [stats,setStats] = useState([]);
    const [val_type,setValType] = useState(null);
    const [types,setTypes] = useState([]);
    const [stat_type_columns, setStatTypeColumns] = useState([]);
    useEffect(() => {
        //Storage.post_dashboard_side_bar(Portal_Table.USER);
        //Toast_Message.loading(Message.LOADING);
        //get_data();
  },[]);
    async function get_data() {
        /*
        bind_items();
        post_search('Type.STAT_LOGIN');
        Toast_Message.dismiss();
        */
    };
   async function bind_items(){
       /*
        let set_types = Data.get_type_categorys(Data.get_admin_stat_types());
        set_stat_type_columns('Type.STAT_LOGIN');
        setTypes(set_types);
        setValType(set_types.find(option => option.value === 'Type.STAT_LOGIN'));
        */
    };
 const set_stat_type_columns = (stat_type) => {
     switch(stat_type){
         /*
        case Type.STAT_CART:
        setStatTypeColumns(get_stat_type_cart_column_list());
        break;
        case Type.STAT_CART_ITEM:
        setStatTypeColumns(get_stat_type_cart_item_column_list());
        break;
        case Type.STAT_CART_SUB_ITEM:
        setStatTypeColumns(get_stat_type_cart_item_column_list());
        break;
        case Type.STAT_ORDER:
        setStatTypeColumns(get_stat_type_order_column_list());
        break;
        case Type.STAT_ORDER_ITEM:
        setStatTypeColumns(get_stat_type_order_item_column_list());
        break;
        case Type.STAT_ORDER_SUB_ITEM:
        setStatTypeColumns(get_stat_type_order_item_column_list());
        break;
        case Type.STAT_ORDER_PAYMENT:
        setStatTypeColumns(get_stat_type_order_payment_column_list());
        break;
        case Type.STAT_FAVORITE:
        case Type.STAT_VIEW:
        setStatTypeColumns(get_stat_type_item_column_list());
        break;
        case Type.STAT_REVIEW:
        setStatTypeColumns(get_stat_type_review_column_list());
        break;
        */
         default:
         setStatTypeColumns(get_stat_type_column_list());
         break;
         };
         /* -- base cols start -- */
    function get_stat_type_column_list(){ return [
    {
    title: "UserName",
       dataIndex: "user_title",
       key: "user_title",
    render: (text: string, record: any) => (
            <>
            <h2 className="table-avatar d-flex align-items-center">
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user_id} className="avatar">
                   <ImageWithBasePath src={Image.get_url(record.user.image_filename,Image_Format.SQUARE_THUMB)} />
                   </Link>
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user_id} className="text-dark">
                   {record.user_title}
                   </Link>
                   </h2>
                   </>
        ),
           sorter: true
    },
    {
    title: "Role",
       dataIndex: "user_role",
       key: "user_role",
    render: (text: string, record: any) => (
            <>
            {Str.get_table_by_name((record.user_role))}
            </>
        ),
       sorter: true
    },
    {
    title: "Date & Time",
       dataIndex: "date_create",
       key: "date_create",
    render: (text: string, record: any) => (
            <>
            {DateTime.get_date(record.date_create)}{" "}
            {DateTime.get_time(record.date_create)}
            </>
        ),
          sorter: true
    },
    {
    title: "Location",
       dataIndex: "location",
        render: (text: string, record: any) => (
            <>
            {record.city_name}{" "}
            {record.region_name}{" "}
            {record.district}<br/>
            {record.zip_code}{" "}
            {record.country_name}
            </>
        ),
       sorter: true
    },
    {
    title: "Device",
       dataIndex: "platform_name",
       key: "platform_name",
        render: (text: string, record: any) => (
            <>
            {record.platform_name}{" "}
            {record.platform_os}{" "}
            {record.platform_version}<br/>
            {record.platform_layout}{" "}
            {record.platform_description}
            </>
        ),
         sorter: true
  },
    {
    title: "Internet Service Provider",
       dataIndex: "isp",
       key: "isp",
        render: (text: string, record: any) => (
            <>
            {record.isp}{" "}
            </>
        ),
         sorter: true
    },
    {
    title: "IP Address",
       dataIndex: "ip_address",
       sorter: (a: any, b: any) => a.ip_address.length - b.ip_address.length,
    },
    {
       title: "Latitude & Longitude",
       dataIndex: "latitude",
       key: "latitude",
       render: (text: string, record: any) => (
            <>
            {record.latitude}<br/>
            {record.longitude}
            </>
        ),
         sorter: true
    },
     ];
    };
         /* -- base cols end -- */
        /* -- item cols start -- */
    function get_stat_type_item_column_list(){ return [
 {
        title: "UserName",
        dataIndex: "user_title",
        key: "user_title",
        render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user_id} className="avatar">
                   <ImageWithBasePath src={Image.get_url(record.user.image_filename,Image_Format.SQUARE_THUMB)} />
                   </Link>
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user_id} className="text-dark">
                   {record.user_title}
                   </Link>
                   </h2>
                   ),
             sorter: true
    },
    {
        title: "Title",
        dataIndex: "parent_title",
        key: "parent_title",
        render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link target="_blank" to={Url.APP_DETAIL+record.parent_title_url} className="avatar">
                   <ImageWithBasePath src={Image.get_url(record.parent_image_filename,Image_Format.SQUARE_THUMB)} />
                   </Link>
                   <Link  target="_blank" to={Url.APP_DETAIL+record.parent_title_url} className="text-dark">
                   {record.parent_title}
                   </Link>
                   </h2>
                   ),
             sorter: true
    },
    {
       title: 'Cost',
       dataIndex: 'parent_cost',
       key: 'parent_cost',
       render: (text: string, record: any) => (
               <>
               {Str.get_money(record.parent_cost)} <br/>
               </>
               ),
       sorter: true
    },
 {
       title: 'Type',
       dataIndex: 'parent_type',
       key: 'parent_type',
       render: (text: string, record: any) => (
               <>
               {record.parent_type} <br/>
               </>
               ),
             sorter: true
    },
 {
       title: 'Category',
       dataIndex: 'parent_category',
       key: 'parent_category',
       render: (text: string, record: any) => (
               <>
               {record.parent_category} <br/>
               </>
               ),
             sorter: true
    },
{
    title: "Date & Time",
       dataIndex: "date_create",
       key: "date_create",
    render: (text: string, record: any) => (
            <>
            {DateTime.get_date(record.date_create)}{" "}
            {DateTime.get_time(record.date_create)}
            </>
        ),
          sorter: true
    },
      ];
    };
       /* -- item cols end -- */
           /* -- CART COLS START -- */
    function get_stat_type_cart_column_list(){ return [
 {
        title: "UserName",
        dataIndex: "user_title",
        key: "user_title",
        render: (text: string, record: any) => (
                    <h2 className="table-avatar d-flex align-items-center">
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user_id} className="avatar">
                   <ImageWithBasePath src={Image.get_url(record.user.image_filename,Image_Format.SQUARE_THUMB)} />
                   </Link>
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user_id} className="text-dark">
                   {record.user_title}
                   </Link>
                   </h2>
                  ),
             sorter: true
    },
    {
       title: 'Grand Total',
       dataIndex: 'grand_total',
       key: 'grand_total',
       render: (text: string, record: any) => (
               <>
               {Str.get_money(record.grand_total)} <br/>
               </>
               ),
       sorter: true
    },
 {
        title: "Cart #",
        dataIndex: "cart_number",
        key: "cart_number",
        render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link to={all_routes.dashboard_admin_cart_detail+"?cart_number="+record.cart_number} className="text-dark">
                   {record.cart_number}
                   </Link>
                   </h2>
                   ),
             sorter: true
    },
{
    title: "Date & Time",
       dataIndex: "date_create",
       key: "date_create",
    render: (text: string, record: any) => (
            <>
            {DateTime.get_date(record.date_create)}{" "}
            {DateTime.get_time(record.date_create)}
            </>
        ),
          sorter: true
    },
      ];
    };
       /* -- CART COLS END -- */


           /* -- ORDER COLS START -- */
    function get_stat_type_order_column_list(){ return [
 {
        title: "UserName",
        dataIndex: "user_title",
        key: "user_title",
        render: (text: string, record: any) => (
                    <h2 className="table-avatar d-flex align-items-center">
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user_id} className="avatar">
                   <ImageWithBasePath src={Image.get_url(record.user.image_filename,Image_Format.SQUARE_THUMB)} />
                   </Link>
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user_id} className="text-dark">
                   {record.user_title}
                   </Link>
                   </h2>
                  ),
             sorter: true
    },
    {
       title: 'Grand Total',
       dataIndex: 'grand_total',
       key: 'grand_total',
       render: (text: string, record: any) => (
               <>
               {Str.get_money(record.grand_total)} <br/>
               </>
               ),
       sorter: true
    },
 {
        title: "Order #",
        dataIndex: "order_number",
        key: "order_number",
        render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link  to={all_routes.dashboard_admin_order_detail+"?order_number="+record.order_number} className="text-dark">
                   {record.order_number}
                   </Link>
                   </h2>
                   ),
             sorter: true
    },
{
    title: "Date & Time",
       dataIndex: "date_create",
       key: "date_create",
    render: (text: string, record: any) => (
            <>
            {DateTime.get_date(record.date_create)}{" "}
            {DateTime.get_time(record.date_create)}
            </>
        ),
          sorter: true
    },
      ];
    };
       /* -- ORDER COLS END -- */
 /* -- ORDER ITEM COLS START -- */
    function get_stat_type_order_item_column_list(){ return [
 {
        title: "UserName",
        dataIndex: "user_title",
        key: "user_title",
        render: (text: string, record: any) => (
                    <h2 className="table-avatar d-flex align-items-center">
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user_id} className="avatar">
                   <ImageWithBasePath src={Image.get_url(record.user.image_filename,Image_Format.SQUARE_THUMB)} />
                   </Link>
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user_id} className="text-dark">
                   {record.user_title}
                   </Link>
                   </h2>
                  ),
             sorter: true
    },
    {
        title: "Title",
        dataIndex: "parent_title",
        key: "parent_title",
        render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link target="_blank" to={Url.APP_DETAIL+record.parent_title_url} className="avatar">
                   <ImageWithBasePath src={Image.get_url(record.parent_image_filename,Image_Format.SQUARE_THUMB)} />
                   </Link>
                   <Link  target="_blank" to={Url.APP_DETAIL+record.parent_title_url} className="text-dark">
                   {record.parent_title}
                   </Link>
                   </h2>
                   ),
             sorter: true
    },
    {
       title: 'Cost',
       dataIndex: 'parent_cost',
       key: 'parent_cost',
       render: (text: string, record: any) => (
               <>
               {Str.get_money(record.parent_cost)} <br/>
               </>
               ),
       sorter: true
    },
 {
        title: "Order #",
        dataIndex: "order_number",
        key: "order_number",
        render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link to={all_routes.dashboard_admin_order_detail+"?order_number="+record.order_number} className="text-dark">
                   {record.order_number}
                   </Link>
                   </h2>
                   ),
             sorter: true
    },
 {
       title: 'Type',
       dataIndex: 'parent_type',
       key: 'parent_type',
       render: (text: string, record: any) => (
               <>
               {record.parent_type} <br/>
               </>
               ),
             sorter: true
    },
 {
       title: 'Category',
       dataIndex: 'parent_category',
       key: 'parent_category',
       render: (text: string, record: any) => (
               <>
               {record.parent_category} <br/>
               </>
               ),
             sorter: true
    },
{
    title: "Date & Time",
       dataIndex: "date_create",
       key: "date_create",
    render: (text: string, record: any) => (
            <>
            {DateTime.get_date(record.date_create)}{" "}
            {DateTime.get_time(record.date_create)}
            </>
        ),
          sorter: true
    },
      ];

    };
       /* -- ORDER ITEM COLS END -- */


    /* -- CART ITEM COLS START -- */
    function get_stat_type_cart_item_column_list(){ return [
 {
        title: "UserName",
        dataIndex: "user_title",
        key: "user_title",
        render: (text: string, record: any) => (
                    <h2 className="table-avatar d-flex align-items-center">
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user_id} className="avatar">
                   <ImageWithBasePath src={Image.get_url(record.user.image_filename,Image_Format.SQUARE_THUMB)} />
                   </Link>
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user_id} className="text-dark">
                   {record.user_title}
                   </Link>
                   </h2>
                  ),
             sorter: true
    },
    {
        title: "Title",
        dataIndex: "parent_title",
        key: "parent_title",
        render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link target="_blank" to={Url.APP_DETAIL+record.parent_title_url} className="avatar">
                   <ImageWithBasePath src={Image.get_url(record.parent_image_filename,Image_Format.SQUARE_THUMB)} />
                   </Link>
                   <Link  target="_blank" to={Url.APP_DETAIL+record.parent_title_url} className="text-dark">
                   {record.parent_title}
                   </Link>
                   </h2>
                   ),
             sorter: true
    },
    {
       title: 'Cost',
       dataIndex: 'parent_cost',
       key: 'parent_cost',
       render: (text: string, record: any) => (
               <>
               {Str.get_money(record.parent_cost)} <br/>
               </>
               ),
       sorter: true
    },
 {
        title: "Cart #",
        dataIndex: "cart_number",
        key: "cart_number",
        render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link  to={all_routes.dashboard_admin_cart_detail+"?cart_number="+record.cart_number} className="text-dark">
                   {record.cart_number}
                   </Link>
                   </h2>
                   ),
             sorter: true
    },
 {
       title: 'Type',
       dataIndex: 'parent_type',
       key: 'parent_type',
       render: (text: string, record: any) => (
               <>
               {record.parent_type} <br/>
               </>
               ),
             sorter: true
    },
 {
       title: 'Category',
       dataIndex: 'parent_category',
       key: 'parent_category',
       render: (text: string, record: any) => (
               <>
               {record.parent_category} <br/>
               </>
               ),
             sorter: true
    },
{
    title: "Date & Time",
       dataIndex: "date_create",
       key: "date_create",
    render: (text: string, record: any) => (
            <>
            {DateTime.get_date(record.date_create)}{" "}
            {DateTime.get_time(record.date_create)}
            </>
        ),
          sorter: true
    },
      ];

    };
       /* -- CART ITEM COLS END -- */

               /* -- review cols start -- */
    function get_stat_type_review_column_list(){ return [
 {
        title: "UserName",
        dataIndex: "user_title",
        key: "user_title",
        render: (text: string, record: any) => (
                    <h2 className="table-avatar d-flex align-items-center">
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user_id} className="avatar">
                   <ImageWithBasePath src={Image.get_url(record.user.image_filename,Image_Format.SQUARE_THUMB)} />
                   </Link>
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user_id} className="text-dark">
                   {record.user_title}
                   </Link>
                   </h2>
                  ),
             sorter: true
    },
    {
        title: "Title",
        dataIndex: "parent_title",
        key: "parent_title",
        render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link to={"#"} className="avatar">
                   <ImageWithBasePath src={Image.get_url(record.parent_image_filename,Image_Format.SQUARE_THUMB)} />
                   </Link>
                   <Link to={"#"} className="text-dark">
                   {record.parent_title}
                   </Link>
                   </h2>
                   ),
             sorter: true
    },
 {
       title: 'Rating',
       dataIndex: 'rating',
       key: 'rating',
       render: (text: string, record: any) => (
               <>
               {record.rating} <br/>
               </>
               ),
       sorter: true
    },
 {
    title: "Date & Time",
       dataIndex: "date_create",
       key: "date_create",
    render: (text: string, record: any) => (
            <>
            {DateTime.get_date(record.date_create)}{" "}
            {DateTime.get_time(record.date_create)}
            </>
        ),
          sorter: true
    },

   {
       title: 'Comment',
       dataIndex: 'comment',
       key: 'comment',
       render: (text: string, record: any) => (
               <>
               {record.comment} <br/>
               </>
               ),
        sorter: true
    },
    {
       title: 'Cost',
       dataIndex: 'parent_cost',
       key: 'parent_cost',
       render: (text: string, record: any) => (
               <>
               {Str.get_money(record.parent_cost)} <br/>
               </>
               ),
       sorter: true
    },
 {
       title: 'Type',
       dataIndex: 'parent_type',
       key: 'parent_type',
       render: (text: string, record: any) => (
               <>
               {record.parent_type} <br/>
               </>
               ),
             sorter: true
    },
 {
       title: 'Category',
       dataIndex: 'parent_category',
       key: 'parent_category',
       render: (text: string, record: any) => (
               <>
               {record.parent_category}
               </>
               ),
             sorter: true
    },
     ];
    };
       /* -- cart cols end -- */

 /* -- ORDER_PAYMENT COLS START -- */
    function get_stat_type_order_payment_column_list(){ return [
 {
        title: "UserName",
        dataIndex: "user_title",
        key: "user_title",
        render: (text: string, record: any) => (
                      <h2 className="table-avatar d-flex align-items-center">
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user_id} className="avatar">
                   <ImageWithBasePath src={Image.get_url(record.user.image_filename,Image_Format.SQUARE_THUMB)} />
                   </Link>
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user_id} className="text-dark">
                   {record.user_title}
                   </Link>
                   </h2>
                ),
             sorter: true
    },
    {
       title: 'Payment Amount',
       dataIndex: 'payment_amount',
       key: 'payment_amount',
       render: (text: string, record: any) => (
               <>
               {Str.get_money(record.payment_amount)} <br/>
               </>
               ),
       sorter: true
    },
 {
       title: 'Payment Method Type',
       dataIndex: 'payment_method_type',
       key: 'payment_method_type',
       render: (text: string, record: any) => (
               <>
               {record.payment_method_type} <br/>
               </>
               ),
       sorter: true
    },
 {
       title: 'Transaction ID',
       dataIndex: 'transaction_id',
       key: 'transaction_id',
       render: (text: string, record: any) => (
               <>
               {Str.get_title(record.transaction_id)} <br/>
               </>
               ),
             sorter: true
    },


 {
        title: "Order #",
        dataIndex: "order_number",
        key: "order_number",
        render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link to={all_routes.dashboard_admin_order_detail+"?order_number="+record.order_number} className="text-dark">
                   {record.order_number}
                   </Link>
                   </h2>
                   ),
             sorter: true
    },
{
    title: "Date & Time",
       dataIndex: "date_create",
       key: "date_create",
    render: (text: string, record: any) => (
            <>
            {DateTime.get_date(record.date_create)}{" "}
            {DateTime.get_time(record.date_create)}
            </>
        ),
          sorter: true
    },
      ];
    };
       /* -- ORDER COLS END -- */


 };
 async function post_search(val_type) {
     /*
        Toast_Message.loading(Message.SEARCHING);
        let filter = Data.get_admin_stat_search_filter(val_type);
        let option = Data.get_stat_search_option(Portal_Table.PRODUCT,val_type);
        let search = Data_Logic.get_search(Portal_Table.STAT,filter);
	    let [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search,option);
        set_stat_type_columns(val_type);
        //setStats(Data_Logic.bind_item_parent_users(data.items));
        Toast_Message.dismiss();
        */
   };
    const updateValType = (selectedOption) => {
        /*
        let search = Data_Logic.get_search(Portal_Table.BLOG_POST,Data.get_type_category_search_filter(selectedOption.label,"Any"),{title:1},1,0);
        setValType(selectedOption);
        switch(selectedOption.value){
            case Type.STAT_LOGIN:
            case Type.STAT_REGISTER:
            case Type.STAT_CART:
            case Type.STAT_FAVORITE:
            case Type.STAT_VIEW:
            case Type.STAT_ORDER:
            case Type.STAT_REVIEW:
            break;
            default:
            break;
        }
        post_search(selectedOption.value);
        */
    };
    return (
            <>
            <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="container px-0">
            {/*Inner Content */}
            <div className="content mx-4 mb-4">
            <div className="main-title my-4">
            <h4>{val_sub_page_title}</h4>
            </div>
            <div className="wallet-wrap">
            <div className="wallet-list">
            <div className="wallet-item mt-10">
            <div  className="pt-10">
            <input hidden={true} type='text' autoComplete='off' className='form-control' placeholder={"Search "+ Str.get_table_by_name(Portal_Table.STAT,{plural:true})} value={val_search} onChange={post_search}/>
            </div>
            </div>
            </div>
            <div className="d-flex align-items-center">
            <Link hidden={true} to="#" data-bs-toggle="modal" data-bs-target="#withdraw" className="btn btn-primary">
            Add
            </Link>
            </div>
            </div>
            <div className="table-filter pb-4">
            <ul className="filter-item">
            <li>
            <div className="dropdown">
            <Select  placeholder={'Filter Type'}  classNamePrefix="react-select" className="select" styles={Style.customStyles}  options={types} value={val_type} onChange={updateValType} />
            </div>
            </li>
            </ul>
            </div>
            <div className="table-responsive custom-table">
           <Table allow_multiple={false}  table={Portal_Table.STAT} dataSource={stats} columns={stat_type_columns} Selection={false} />
            </div>
            <div className="table-footer">
            <div id="tablepage" />
            </div>
            </div>
            {/* /Inner Content */}
    </div>
        </div>
        {/* /Page Content */}
        </>
        );
};
export default Dashboard_Admin_Stat;
